import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatType } from '@core-lib/enums';
import { formatDate } from '@core-lib/functions';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
	transform(date: Date, dateFormatType: DateFormatType = DateFormatType.DDMMYYYY): string {
		return formatDate(date, dateFormatType);
	}
}
